import axios from 'axios';
// import {
//   Message,
// } from 'ant-design-vue';
import router from '../router';
import store from '../store';
import {
  message, Modal } from 'ant-design-vue';

message.config({
  duration: 2, // 提示时常单位为s
  top: '40px', // 距离顶部的位置
  maxCount: 3 // 最多显示提示信息条数(后面的会替换前面的提示)
});
export default function defaultFetch() {
}

export async function fetch(options) {
  const instance = await axios.create({
    timeout: 1000 * 60, // 超时  (设定请求时长 60s)
    headers: {
      token: localStorage.getItem('token'),
    },
  });
  try {
    const result = await instance(options);
    if (result.code === 16003 || result.status === 401) {
      message.error(result.message);
      store.commit('clearLoginInfo');
      await router.push('/login');
      return result;
    }
    if (result.status === 200) {
      return result.data || {};
    }
    message.error(result.message);
    return result || {};
  } catch (error) {
    const { response } = error;
    if (response.status === 401) {
      message.error(response.data.message, 2);
    }
    if (response.status === 500) {
      message.error(response.data.message, 2);
    }
    if (response.status === 403) {
      message.error(response.data.message, 2);
    }
    if (response.status === 404) {
      message.error(response.data.message, 2);
    }
    return null;
  }
}
